export const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
export const phoneRegex = /^((\+)?(\d{2}[-]))?(\d{10}){1}?$/;
export const postalCode = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;
export const numberQuantity = /^0$|^[1-9][0-9]*$/;

